// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.f1deca312',
  revision: 'f1deca312',
  branch: 'develop',
  date: 'Wed, 16 Sep 2026 13:57:37 GMT'
};